(function () {
  var ROOT_SELECTOR = '[data-product-package-root]';
  var INITIALIZED_ATTR = 'data-product-package-initialized';

  var selectors = {
    packOption: '[data-pack-option]',
    purchaseInput: 'input[name="product-package-purchase-type"]',
    savePill: '[data-save-pill]',
    form: 'form[data-type="add-to-cart-form"]',
    variantInput: '[data-package-variant-id]',
    qtyInput: '[data-package-qty]',
    sellingPlanInput: '[data-package-selling-plan]',
    submitButton: 'button[type="submit"][name="add"]'
  };

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function getCheckIconSvg() {
    return (
      '<svg class="product-package__check-svg" viewBox="0 0 14 14" fill="none">' +
      '<path d="M2 7.5l3 3 7-7" stroke="#03acf0" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"></path>' +
      '</svg>'
    );
  }

  function replaceTemplateTokens(template, savePercentText, frequencyText) {
    return String(template || '')
      .replace(/\{save_percent\}/g, savePercentText || '')
      .replace(/\{selling_plan_frequency\}/g, frequencyText || '');
  }

  function sanitizeBenefitHtml(value) {
    return String(value || '')
      .replace(/<strong[^>]*>/gi, '<strong>')
      .replace(/<\/strong[^>]*>/gi, '</strong>')
      .replace(/<(?!\/?strong>)[^>]*>/gi, '');
  }

  function initProductPackage(productSection) {
    if (!productSection || productSection.hasAttribute(INITIALIZED_ATTR)) return;
    productSection.setAttribute(INITIALIZED_ATTR, 'true');

    var elements = {
      packs: toArray(productSection.querySelectorAll(selectors.packOption)),
      purchaseInputs: toArray(productSection.querySelectorAll(selectors.purchaseInput)),
      subWrap: productSection.querySelector('#lgd-sub-wrap'),
      otpWrap: productSection.querySelector('#lgd-otp-wrap'),
      subBanner: productSection.querySelector('#lgd-sub-banner'),
      bannerPercent: productSection.querySelector('#lgd-banner-percent'),
      subCompare: productSection.querySelector('#lgd-compare-price'),
      subPrice: productSection.querySelector('#lgd-sub-price'),
      otpCompare: productSection.querySelector('#lgd-otp-compare'),
      otpPrice: productSection.querySelector('#lgd-otp-price'),
      subBenefits: productSection.querySelector('#lgd-sub-benefits'),
      subBenefitsTemplate: productSection.querySelector('[data-subscription-benefits-template]'),
      atcPrice: productSection.querySelector('[data-atc-price]'),
      form: productSection.querySelector(selectors.form)
    };

    elements.variantInput = elements.form ? elements.form.querySelector(selectors.variantInput) : null;
    elements.qtyInput = elements.form ? elements.form.querySelector(selectors.qtyInput) : null;
    elements.sellingPlanInput = elements.form ? elements.form.querySelector(selectors.sellingPlanInput) : null;
    elements.submitButton = elements.form ? elements.form.querySelector(selectors.submitButton) : null;

    var moneyFormat = productSection.dataset.moneyFormat || '{{amount}}';
    var defaultPurchaseType = productSection.dataset.defaultPurchaseType || 'subscription';
    var useManualOnetimeSavings = productSection.dataset.useManualOnetimeSavings === 'true';

    function formatMoney(cents) {
      var value = Number(cents || 0);

      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(value, moneyFormat);
      }

      var amount = (value / 100).toFixed(2);
      var amountNoDecimals = Math.round(value / 100).toString();

      if (moneyFormat) {
        return moneyFormat
          .replace(/\{\{\s*amount\s*\}\}/g, amount)
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
          .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimals);
      }

      return amount;
    }

    function getSelectedPack() {
      return elements.packs.find(function (pack) {
        var input = pack.querySelector('input[type="radio"]');
        return input && input.checked;
      }) || elements.packs[0];
    }

    function getPurchaseType() {
      var selectedInput = elements.purchaseInputs.find(function (input) {
        return input.checked;
      });

      if (!selectedInput) return defaultPurchaseType;

      var purchaseCard = selectedInput.closest('[data-type]');
      var type = purchaseCard ? purchaseCard.dataset.type : '';

      if (type === 'subscribe') return 'subscription';
      if (type === 'onetime') return 'onetime';

      return defaultPurchaseType;
    }

    function setPurchaseType(type) {
      var input = productSection.querySelector(
        type === 'subscription'
          ? '#product-package-purchase-type-subscribe'
          : '#product-package-purchase-type-otp'
      );

      if (input) input.checked = true;
    }

    function getManualOnetimeDiscount(pack) {
      if (!pack || !useManualOnetimeSavings) return 0;

      var rawDiscount = String(pack.dataset.oneManualDiscount || '0')
        .replace('%', '')
        .trim();

      var discount = parseFloat(rawDiscount);

      if (Number.isNaN(discount) || discount <= 0) return 0;
      if (discount > 100) return 100;

      return discount;
    }

    function getDiscountedPrice(priceCents, discountPercent) {
      var price = Number(priceCents || 0);
      var discount = Number(discountPercent || 0);

      if (!price || !discount || discount <= 0) return price;

      return Math.round(price * (1 - discount / 100));
    }

    function getSavePercent(pack, purchaseType) {
      if (!pack) return 0;

      if (purchaseType === 'onetime') {
        var manualDiscount = getManualOnetimeDiscount(pack);

        if (manualDiscount > 0) {
          return manualDiscount;
        }
      }

      return Number(
        purchaseType === 'subscription'
          ? pack.dataset.subSavePercent || 0
          : pack.dataset.oneSavePercent || 0
      );
    }

    function getEachPrice(totalCents, bottleCount) {
      var count = Number(bottleCount || 1);
      var safeCount = count > 0 ? count : 1;

      return formatMoney(Math.round(Number(totalCents || 0) / safeCount));
    }

    function updatePrice(compareEl, priceEl, compareCents, priceCents, bottleCount) {
      if (priceEl) {
        priceEl.textContent = getEachPrice(priceCents, bottleCount) + '/each';
      }

      if (!compareEl) return;

      if (Number(compareCents || 0) > Number(priceCents || 0)) {
        compareEl.textContent = getEachPrice(compareCents, bottleCount);
        compareEl.style.removeProperty('display');
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    }

    function updatePackSelection() {
      elements.packs.forEach(function (pack) {
        var input = pack.querySelector('input[type="radio"]');
        pack.classList.toggle('active', Boolean(input && input.checked));
      });
    }

    function updatePurchaseSelection(purchaseType) {
      if (elements.subWrap) {
        elements.subWrap.classList.toggle('active', purchaseType === 'subscription');
      }

      if (elements.otpWrap) {
        elements.otpWrap.classList.toggle('active', purchaseType === 'onetime');
      }
    }

    function updateSaveBadges(purchaseType) {
      elements.packs.forEach(function (pack) {
        var badge = pack.querySelector(selectors.savePill);
        if (!badge) return;

        var savePercent = getSavePercent(pack, purchaseType);

        if (savePercent > 0) {
          badge.textContent = 'Save ' + savePercent + '%';
          badge.style.removeProperty('display');
        } else {
          badge.textContent = '';
          badge.style.display = 'none';
        }
      });
    }

    function updateSubscriptionBanner(pack) {
      if (!elements.subBanner) return;

      var savePercent = getSavePercent(pack, 'subscription');
      var frequency = pack.dataset.sellingPlanFrequency || '';
      var bannerTemplate = elements.subBanner.dataset.subscriptionBannerTemplate || '';

      if (bannerTemplate) {
        elements.subBanner.innerHTML = replaceTemplateTokens(
          bannerTemplate,
          savePercent + '%',
          frequency
        );
        return;
      }

      if (elements.bannerPercent) {
        elements.bannerPercent.textContent = savePercent + '%';
      }
    }

    function renderSubscriptionBenefits(pack) {
      if (!elements.subBenefits || !elements.subBenefitsTemplate) return;

      var savePercent = getSavePercent(pack, 'subscription');
      var frequency = pack.dataset.sellingPlanFrequency || '';
      var templateText = elements.subBenefitsTemplate.value || elements.subBenefitsTemplate.textContent || '';

      var lines = templateText
        .split(/\r?\n/)
        .map(function (line) {
          return line.trim();
        })
        .filter(Boolean);

      if (!lines.length) {
        elements.subBenefits.innerHTML = '';
        elements.subBenefits.hidden = true;
        return;
      }

      elements.subBenefits.hidden = false;

      var html = lines.map(function (line) {
        var lineHtml = replaceTemplateTokens(line, savePercent + '%', frequency);
        lineHtml = sanitizeBenefitHtml(lineHtml);

        if (!lineHtml.trim()) return '';

        return (
          '<div class="product-package__benefit">' +
          getCheckIconSvg() +
          '<span class="product-package__benefit-text">' +
          lineHtml +
          '</span>' +
          '</div>'
        );
      }).join('');

      elements.subBenefits.innerHTML = html;

      if (!html.trim()) {
        elements.subBenefits.hidden = true;
      }
    }

    function updateSubscriptionTexts(pack) {
      updateSubscriptionBanner(pack);
      renderSubscriptionBenefits(pack);
    }

    function updateCartForm(pack, purchaseType) {
      var variantId = pack.dataset.variantId || '';
      var sellingPlanId = pack.dataset.sellingPlanId || '';
      var isAvailable = pack.dataset.available === 'true';

      if (elements.variantInput) {
        elements.variantInput.value = variantId;
        elements.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (elements.qtyInput) {
        elements.qtyInput.value = '1';
        elements.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (elements.sellingPlanInput) {
        if (purchaseType === 'subscription' && sellingPlanId) {
          elements.sellingPlanInput.disabled = false;
          elements.sellingPlanInput.value = sellingPlanId;
        } else {
          elements.sellingPlanInput.disabled = true;
          elements.sellingPlanInput.value = '';
        }

        elements.sellingPlanInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (elements.submitButton) {
        elements.submitButton.disabled = !variantId || !isAvailable;
        elements.submitButton.style.display = isAvailable ? '' : 'none';
      }
    }

    function sync() {
      var selectedPack = getSelectedPack();
      if (!selectedPack) return;

      var purchaseType = getPurchaseType();
      var subscriptionAvailable = selectedPack.dataset.subAvailable === 'true';

      if (purchaseType === 'subscription' && !subscriptionAvailable) {
        setPurchaseType('onetime');
        purchaseType = 'onetime';
      }

      var bottleCount = selectedPack.dataset.bottleCount || '1';
      var oneTimePrice = Number(selectedPack.dataset.price || 0);
      var comparePrice = Number(selectedPack.dataset.compare || oneTimePrice);
      var subscriptionPrice = Number(selectedPack.dataset.subPrice || oneTimePrice);

      var manualDiscount = getManualOnetimeDiscount(selectedPack);
      var onetimeDisplayPrice = oneTimePrice;
      var onetimeComparePrice = comparePrice;

      if (manualDiscount > 0) {
        onetimeDisplayPrice = getDiscountedPrice(oneTimePrice, manualDiscount);
        onetimeComparePrice = oneTimePrice;
      }

      updatePackSelection();
      updatePurchaseSelection(purchaseType);

      updatePrice(
        elements.subCompare,
        elements.subPrice,
        comparePrice,
        subscriptionPrice,
        bottleCount
      );

      updatePrice(
        elements.otpCompare,
        elements.otpPrice,
        onetimeComparePrice,
        onetimeDisplayPrice,
        bottleCount
      );

      updateSaveBadges(purchaseType);
      updateSubscriptionTexts(selectedPack);

      if (elements.atcPrice) {
        var atcTotalPrice = purchaseType === 'subscription' ? subscriptionPrice : onetimeDisplayPrice;
        elements.atcPrice.textContent = formatMoney(atcTotalPrice);
      }

      updateCartForm(selectedPack, purchaseType);
    }

    productSection.addEventListener('click', function (event) {
      var pack = event.target.closest(selectors.packOption);
      if (!pack || !productSection.contains(pack)) return;

      var input = pack.querySelector('input[type="radio"]');
      if (input) input.checked = true;

      sync();
    });

    elements.purchaseInputs.forEach(function (input) {
      input.addEventListener('change', sync);
    });

    sync();
  }

  function initAll(scope) {
    toArray((scope || document).querySelectorAll(ROOT_SELECTOR)).forEach(initProductPackage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });
})();
